import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from './styles';
import { useHistory } from 'react-router';
import { FormAddEdit } from '../components/FormAddEdit';
import styleText from '../../../../shared/components/rbh-text/styles';
import { RBHBox, RBHText } from '../../../../shared/components';
import stylesHead from '../../VatAddress/styles';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { useDispatch, useSelector } from 'react-redux';
import { mainCreators } from '../../../main-action';
import { MAIN_STATE_KEY } from '../../../main-reducer';
import { VAT_STATE_KEY, vatStateSelector } from '../redux/vat-reducer';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { VAT_REQUEST_ID_LIST } from '../redux/vat-constant';
import { VatService } from '../redux/vat-service';
import { vatSagas } from '../redux/vat-saga';

export const AddVatAddressScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const prefillData = useSelector(vatStateSelector(VAT_STATE_KEY.PREFILL));

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 3));
    if (!prefillData) {
      pushToVatAddress();
    } else {
      callVat();
    }
  }, []);

  const callVat = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(httpCreators.request({
      id: VAT_REQUEST_ID_LIST.GET_VAT,
      sagaHandler: vatSagas.getVatAddHandler as any,
      callbackParams: pushToVatAddress,
      service: VatService.getVat,
      serviceParams: ''
    }));
  };

  const pushToMain = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main');
  };

  const pushToVatAddress = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/vataddress');
  };

  const BreadcrumbAddRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breakcrumb_vat_tohomepage'} id={'breakcrumb_vat_tohomepage'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'breakcrumb_vat'} id={'breakcrumb_vat'} style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: pushToVatAddress,
                type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.vat_vataddress'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span id={'breakcrumb_add_vat'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.vat_addaddress'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      <BreadcrumbAddRender />
      <RBHBox>
        <RBHBox style={stylesHead.header}>
          <RBHText id={'add_vat_header'} style={styleText.headerText} text={'main.vat_addaddress'} />
        </RBHBox>
        {prefillData ?
          <RBHBox style={styles.defaultContent}>
            <FormAddEdit onCancel={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
              visible: true,
              onOk: pushToVatAddress,
              type: MODAL_TYPE.CONFIRM_EDIT
            }))}/>
          </RBHBox> : null
        }
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
